(function () {
  const section = document.querySelector('.section-main-blog');
  if (!section) return;

  const filters = section.querySelectorAll('.blog-filters__filter');
  const articles = section.querySelectorAll('.blog-articles__article');
  const paginationWrapper = section.querySelector('.pagination-wrapper');

  function applyFilter(filterValue) {
    filters.forEach(function (btn) {
      btn.classList.remove('active');
    });

    const matchingFilter = Array.from(filters).find(function (btn) {
      return btn.getAttribute('data-filter') === filterValue;
    });

    if (matchingFilter) {
      matchingFilter.classList.add('active');
    }

    articles.forEach(function (article) {
      const categories = article.getAttribute('data-categories');
      const show =
        filterValue === 'all' ||
        (categories && categories.split(/\s+/).indexOf(filterValue) !== -1);

      article.style.display = show ? '' : 'none';
    });

    updatePaginationForFilter(filterValue);
  }

  function updatePaginationForFilter(filterValue) {
    if (!paginationWrapper) return;

    const textEl = paginationWrapper.querySelector('[data-pagination-text]');
    const prevLink = paginationWrapper.querySelector('.pagination__arrow--prev[href]');
    const nextLink = paginationWrapper.querySelector('.pagination__arrow--next[href]');
    const format = paginationWrapper.getAttribute('data-page-of-format');

    if (filterValue === 'all') {
      paginationWrapper.classList.remove('pagination-wrapper--filtered');
      const current = paginationWrapper.getAttribute('data-current-page');
      const total = paginationWrapper.getAttribute('data-total-pages');
      if (textEl && format) {
        textEl.textContent = format
          .replace('__current__', current)
          .replace('__total__', total);
      }
      if (prevLink) {
        const url = paginationWrapper.getAttribute('data-prev-url');
        if (url) {
          prevLink.href = url;
          prevLink.classList.remove('pagination__arrow--disabled');
          prevLink.removeAttribute('aria-disabled');
        }
      }
      if (nextLink) {
        const url = paginationWrapper.getAttribute('data-next-url');
        if (url) {
          nextLink.href = url;
          nextLink.classList.remove('pagination__arrow--disabled');
          nextLink.removeAttribute('aria-disabled');
        }
      }
    } else {
      paginationWrapper.classList.add('pagination-wrapper--filtered');
      if (textEl && format) {
        textEl.textContent = format
          .replace('__current__', '1')
          .replace('__total__', '1');
      }
      if (prevLink) {
        prevLink.removeAttribute('href');
        prevLink.classList.add('pagination__arrow--disabled');
        prevLink.setAttribute('aria-disabled', 'true');
      }
      if (nextLink) {
        nextLink.removeAttribute('href');
        nextLink.classList.add('pagination__arrow--disabled');
        nextLink.setAttribute('aria-disabled', 'true');
      }
    }
  }

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      const filterValue = this.getAttribute('data-filter');
      applyFilter(filterValue);
      
      // Update URL hash
      if (filterValue === 'all') {
        history.replaceState(null, '', window.location.pathname);
      } else {
        history.replaceState(null, '', '#' + filterValue);
      }
    });
  });

  // Handle hash fragment on page load and hash changes
  function handleHashFilter() {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      applyFilter(hash);
    } else {
      // Default to 'all' if no hash
      applyFilter('all');
    }
  }

  // Check hash on page load
  handleHashFilter();

  // Listen for hash changes
  window.addEventListener('hashchange', handleHashFilter);
})();
